import { render, staticRenderFns } from "./where-do-instagram-downloads-go-on-iphone.vue?vue&type=template&id=6d22547d"
import script from "./where-do-instagram-downloads-go-on-iphone.vue?vue&type=script&lang=js"
export * from "./where-do-instagram-downloads-go-on-iphone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports